export class TenantListDTO {

    id: string;

    name: string;

    active: boolean;

    sponsored: boolean;

    trial: boolean;

    vatNo: string;

    createdBy: string;
    
    updatedBy: string;
    
    createdAt: Date;
    
    updatedAt: Date;

}
